function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Text, Title, RedStar, InfoCircle, Spin } from "@dhxete/text";
import { Button } from "@dhxete/button";
import { TextInput, TextArea, Dropdown, RadioInput, CheckboxIP, MaskInput } from "@dhxete/form";
const Ul = styled.ul`
  padding-left: 20px;
  margin: 0 0 20px;
`;

const Paragraph = ({
  BGColor,
  // Check if it has background color
  BGPadding,
  buttonTitle,
  className,
  // Required by styled-component library
  customComponent,
  // Required when isCustomComponent is true
  data,
  // to show loading/data state in input field e.g. CM input field.
  datalist,
  description,
  // Set up the content of this paragraph
  disabled = false,
  // prevents user interactions on Checkbox property
  dispatch,
  enableMask,
  // enable mask input into InputText element.
  endWithInfoCircle = false,
  // Set up the info circle tooltip
  endWithRedStar = false,
  focusIn = false,
  // when you need to put focus byDefault.
  handleButtonClick,
  handleChange,
  handleClose,
  // when user click on close button SVG on input field.
  handleTextClick,
  handleSecondButtonClick,
  handleSubmit,
  handleValidation,
  // field validation function.
  hasBullet = false,
  // Check if it has bullet
  hasErrorMark = false,
  hasLargeBottom = false,
  hasNarrowBottom = false,
  hasSuccessMark = false,
  hoverInfoDescriptions,
  id,
  // unique for elements.
  secondButtonId,
  isButton,
  // Check if it is a Button
  isCheckbox,
  // checkbox to authorize request.
  isChecked = false,
  // check if the checkbox value is true.
  isCustomComponent = false,
  // check if the custom component value is true.
  isDropdown = false,
  // // Check if it is a Dropdown
  isError,
  // field validations.
  isInputMask = false,
  // Check if it is a InputMask - e.g. CM validations.
  isMaskInput = false,
  // Check if it is a InputMask - e.g. CM validations v2.
  isRadioInput = false,
  isShown = true,
  // Check if it is shown or not
  isSpin,
  // Check if it is a Spin
  isTextArea = false,
  // Check if it is a TextArea
  isTextInput = false,
  // Check if it is a TextInput
  isTitle = false,
  // Check if it is a Title
  mask,
  options,
  paragraphStyle,
  // Set up the style of the WHOLE pagraph such as margin-bottom
  placeholder,
  secondButtonTitle,
  showLoadingSpinner = false,
  // loading is for CM
  showCheckmark,
  // show green checkmark for CM field validations
  showClose,
  // shoe close button.
  showError,
  state,
  style,
  // Set up the style of the content itself such as fontWeight
  showWordCount,
  // Text area - Case Creation.
  showGreenTick,
  // show green tick after serial number validations.
  value,
  isAgentAvailable,
  isLoading
}) => {
  if (!isShown) return null;
  if (isSpin) return /*#__PURE__*/React.createElement(Spin, null);
  let res;
  if (isTitle) res = /*#__PURE__*/React.createElement(Title, _extends({
    hasErrorMark: hasErrorMark,
    hasSuccessMark: hasSuccessMark,
    hasNarrowBottom: hasNarrowBottom,
    hasLargeBottom: hasLargeBottom,
    isAgentAvailable: isAgentAvailable
  }, style, {
    id: id
  }), description);else if (isTextInput) res = /*#__PURE__*/React.createElement(TextInput, {
    state: state,
    dispatch: dispatch,
    placeholder: placeholder,
    handleChange: handleChange,
    handleClose: handleClose,
    handleSubmit: handleSubmit,
    datalist: datalist,
    enableMask: enableMask,
    value: value,
    focusIn: focusIn,
    isError: isError,
    id: id,
    isLoading: isLoading,
    handleValidation: handleValidation,
    mask: mask,
    showClose: showClose,
    showGreenTick: showGreenTick
  });else if (isMaskInput) res = /*#__PURE__*/React.createElement(MaskInput, {
    className: className,
    onChange: handleChange,
    id: id,
    mask: mask,
    placeholder: placeholder,
    value: value,
    showError: showError,
    showLoadingSpinner: showLoadingSpinner,
    showCheckmark: showCheckmark
  });else if (isCheckbox) res = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckboxIP, {
    label: "Default",
    disabled: disabled,
    className: className,
    onChange: e => handleChange(e),
    checked: isChecked,
    style: style,
    id: id,
    description: description
  }));else if (isTextArea) res = /*#__PURE__*/React.createElement(TextArea, {
    placeholder: placeholder,
    showWordCount: showWordCount,
    handleChange: handleChange,
    is: id
  });else if (isRadioInput) res = /*#__PURE__*/React.createElement(RadioInput, {
    options: options,
    handleChange: handleChange
  });else if (isDropdown) res = /*#__PURE__*/React.createElement(Dropdown, {
    placeholder: placeholder,
    options: options,
    handleChange: handleChange,
    value: value
  });else if (isButton) res = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    title: buttonTitle,
    handleClick: handleButtonClick,
    id: id
  }), secondButtonTitle && /*#__PURE__*/React.createElement(Button, {
    title: secondButtonTitle,
    handleClick: handleSecondButtonClick,
    id: secondButtonId
  }));else if (isCustomComponent && customComponent) res = customComponent;else res = /*#__PURE__*/React.createElement(Text, _extends({}, style, {
    id: id,
    handleTextClick: handleTextClick
  }), description);
  res = /*#__PURE__*/React.createElement("div", {
    className: className,
    style: paragraphStyle
  }, res, isShown && endWithRedStar && /*#__PURE__*/React.createElement(RedStar, null), isShown && endWithInfoCircle && /*#__PURE__*/React.createElement(InfoCircle, {
    hoverInfoDescriptions: hoverInfoDescriptions
  }));
  return hasBullet ? /*#__PURE__*/React.createElement(Ul, null, /*#__PURE__*/React.createElement("li", null, res)) : res;
};

Paragraph.propTypes = {
  BGColor: PropTypes.string,
  BGPadding: PropTypes.string,
  buttonTitle: PropTypes.string,
  className: PropTypes.string,
  customComponent: PropTypes.object,
  data: PropTypes.bool,
  datalist: PropTypes.array,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  dispatch: PropTypes.func,
  enableMask: PropTypes.bool,
  endWithInfoCircle: PropTypes.bool,
  endWithRedStar: PropTypes.bool,
  focusIn: PropTypes.bool,
  handleButtonClick: PropTypes.func,
  handleChange: PropTypes.func,
  handleClose: PropTypes.func,
  handleSecondButtonClick: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleValidation: PropTypes.func,
  handleTextClick: PropTypes.func,
  hasBullet: PropTypes.bool,
  hasErrorMark: PropTypes.bool,
  hasLargeBottom: PropTypes.bool,
  hasNarrowBottom: PropTypes.bool,
  hasSuccessMark: PropTypes.bool,
  hoverInfoDescriptions: PropTypes.string,
  id: PropTypes.string,
  isButton: PropTypes.bool,
  isCheckbox: PropTypes.bool,
  isChecked: PropTypes.bool,
  isCustomComponent: PropTypes.bool,
  isDropdown: PropTypes.bool,
  isError: PropTypes.bool,
  isInputMask: PropTypes.bool,
  isMaskInput: PropTypes.bool,
  isRadioInput: PropTypes.bool,
  isShown: PropTypes.bool,
  isSpin: PropTypes.bool,
  isTextArea: PropTypes.bool,
  isTextInput: PropTypes.bool,
  isTitle: PropTypes.bool,
  isLoading: PropTypes.bool,
  mask: PropTypes.array,
  options: PropTypes.array,
  paragraphStyle: PropTypes.object,
  placeholder: PropTypes.string,
  secondButtonTitle: PropTypes.string,
  secondButtonId: PropTypes.string,
  showLoadingSpinner: PropTypes.bool,
  showCheckmark: PropTypes.bool,
  showClose: PropTypes.bool,
  showGreenTick: PropTypes.bool,
  showError: PropTypes.bool,
  state: PropTypes.object,
  style: PropTypes.object,
  value: PropTypes.string
};
export default styled(Paragraph)`
  ${props => props.BGColor && css`
    background: ${props.BGColor};
    padding: ${props.BGPadding || "20px"};
  `}
`;